/**
 * Tracks screen views when pathname changes. Render once inside app layout (inside AnalyticsProvider).
 * Uses zporti_screen_viewed for Mixpanel funnel consistency.
 */

import { useEffect, useRef } from 'react'
import { usePathname } from 'expo-router'
import { useAnalytics } from './useAnalytics'
import { pathnameToScreen } from './screenTracker.helper'
import { ANALYTICS_EVENTS } from './events'

export function ScreenTracker() {
  const pathname = usePathname()
  const { track } = useAnalytics()
  const lastScreenRef = useRef<string | null>(null)

  useEffect(() => {
    const screenName = pathnameToScreen(pathname)
    if (!screenName || lastScreenRef.current === screenName) return
    lastScreenRef.current = screenName
    track(ANALYTICS_EVENTS.SCREEN_VIEWED, { screen: screenName, path: pathname })
  }, [pathname, track])

  return null
}
